<template>
  <div class="header">
    <div class="logo-wrap">
      <div class="logo"></div>
      <div class="pc">益盟操盘手</div>
      <div class="line">|</div>
      <div class="mobile">手机产品中心</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['activityIndex']
}
</script>

<style lang="scss" scoped>
.header {
  width: 980px;
  height: 70px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  color: #333;
  margin: 0 auto;
  font-size: 24px;
  .logo-wrap {
    display: flex;
    align-items: center;
    .logo {
      width: 36px;
      height: 36px;
      background: url('./images/logo.png') no-repeat;
      background-size: 100%;
    }
    .pc {
      font-size: 26px;
      font-weight: bold;
      margin-left: 15px;
    }
    .line {
      margin: -3px 15px 0;
    }
  }
}
.mobile {
  .header {
    width: 100%;
    padding: 0 20px;
    height: 50px;
    font-size: 18px;
    .logo-wrap {
      .pc {
        font-size: 22px;
      }
      .line {
        margin: -3px 10px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PcHeader/PcHeader.vue